/**
 * Plus Icon Component
 */

interface PlusIconProps {
  readonly className?: string
}

export default function PlusIcon({ className = 'h-5 w-5' }: PlusIconProps) {
  return (
    <svg
      className={className}
      fill='none'
      stroke='currentColor'
      viewBox='0 0 24 24'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M12 4v16m8-8H4'
      />
    </svg>
  )
}
